module.exports = __webpack_public_path__ + "img/card_at_equipments.50ab7faa.svg";